
import { NavLink, Outlet, useLocation  } from "react-router-dom"

export default function QuizType() {
const location =useLocation();
if(
location.pathname.includes("AR")){
  return (
    <div className="help-layout" dir="rtl">

        <nav><h2> نوع رخصة القيادة </h2></nav>
      <nav className="layout-nav"> 
        <NavLink to="/test/AR/«1»">تراكتور - 1</NavLink>
        <NavLink to="/test/AR/«A»">دراجة نارية - A</NavLink>
        <NavLink to="/test/AR/«B»">مركبة خصوصية - B</NavLink>
        <NavLink to="/test/AR/«C1»">مركبة شحن خفيف - C1</NavLink>
        <NavLink to="/test/AR/«C»">مركبة شحن ثقيل - C</NavLink>
        <NavLink to="/test/AR/«D»">مركبة عمومية - D</NavLink>
      </nav>
     
     

      <Outlet />
      

    </div>
  )
}
else if(location.pathname.includes("EN")){
  return (
    <div className="help-layout" dir="rtl">

        <nav><h2> Driving license type</h2></nav>
      <nav className="layout-nav">
        <NavLink to="/test/EN/«1»">tractor - 1</NavLink>
        <NavLink to="/test/EN/«A»">Motorcycle- A</NavLink>
        <NavLink to="/test/EN/«B»">private vehicle- B</NavLink>
        <NavLink to="/test/EN/«C1»">light cargo vehicle- C1</NavLink>
        <NavLink to="/test/EN/«C»">heavy cargo vehicle- C</NavLink>
        <NavLink to="/test/EN/«D»">public vehicle- D</NavLink>
      </nav>
     
     

      <Outlet />
      

    </div>
  )

}
else if(location.pathname.includes("HE")){
  return (
    <div className="help-layout" dir="rtl">

        <nav><h2> סוג רישיון נהיגה</h2></nav>
      <nav className="layout-nav">
        <NavLink to="/test/HE/«1»">טְרַקטוֹר - 1</NavLink>
        <NavLink to="/test/HE/«A»">אופנוע- A</NavLink>
        <NavLink to="/test/HE/«B»">רכב פרטי - B</NavLink>
        <NavLink to="/test/HE/«C1»">רכב מטען קל- C1</NavLink>
        <NavLink to="/test/HE/«C»">רכב מטען כבד- C</NavLink>
        <NavLink to="/test/HE/«D»">רכב ציבורי- D</NavLink>
      </nav>
     
     

      <Outlet />
      

    </div>
  )

}
 
}
